module.exports = __webpack_public_path__ + "static/media/photo_video_gallery.1a2b00c9.svg";